import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { useState } from 'react';
import { useStartPopup } from '@/hooks/useStartPopup';
import { NAV_PATH } from '@/router/constants';

interface BannerLink {
	src: string;
	action: 'link';
	link: string;
	target?: string;
}

interface BannerPopup {
	src: string;
	action: 'popup';
}

interface BannerFlat {
	src: string;
	action?: undefined;
	link?: undefined;
}

type BannerProps = BannerLink | BannerPopup | BannerFlat;

const popupImages = {
	banner4: require('@/assets/images/common/img_popup4.jpg'),
	banner1: require('@/assets/images/common/img_popup1.jpg'),
	banner2: require('@/assets/images/common/img_popup2.jpg'),
	banner3: require('@/assets/images/common/img_popup3.jpg')
};

const popupBanner: BannerProps[] = [
	{
		src: popupImages.banner4,
		action: 'link',
		link: 'https://tutorial.stella-erp.com',
		target: '_blank'
	},
	{
		src: popupImages.banner3,
		action: 'link',
		link: NAV_PATH.FUNCTION.MAIN + '#attd',
		target: '_self'
	},
	{
		src: popupImages.banner2,
		action: 'link',
		link: NAV_PATH.FUNCTION.CONVENIENCE + '#pharosAI',
		target: '_self'
	},
	{
		src: popupImages.banner1,
		action: 'popup'
	}
];

const PopupBanner = () => {
	const [bannerClosed, setBannerClosed] = useState(false); // 닫기 여부
	const { openStartPopup } = useStartPopup();

	const handleBannerClick = (slide: BannerProps) => {
		if (slide.action === 'popup') {
			openStartPopup();
			return;
		}

		if (slide.action === 'link') {
			if (slide.target === '_blank') {
				window.open(slide.link, '_blank', 'noopener,noreferrer');
			} else {
				window.location.href = slide.link;
			}
		}
	};

	return (
		<div className={`popup-banner ${!bannerClosed ? 'active' : ''}`}>
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				loop
				speed={1000}
				autoplay={{
					delay: 5000
				}}
				pagination={{ clickable: true }}
				observer={true}
				observeParents={true}>
				{popupBanner.map((slide, index) => (
					<SwiperSlide
						key={index}
						onClick={() => handleBannerClick(slide)}
						style={{ cursor: slide.action ? 'pointer' : '' }}>
						<img src={slide.src} alt="" />
					</SwiperSlide>
				))}
				<div className="swiper-pagination"></div>
			</Swiper>

			<div className="popup-banner-btns">
				<button type="button" className="popup-banner-btn btn1 hidden">
					일주일간 보지 않기
				</button>
				<button type="button" className="popup-banner-btn btn2" onClick={() => setBannerClosed(true)}>
					닫기
				</button>
			</div>
		</div>
	);
};

export default PopupBanner;
